import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as NotificationsActions from './notifications.actions';
import { catchError, concatMap, map, of, tap } from 'rxjs';
import { MessagingService } from '../services/messaging.service';
import { NotificationsService } from './notifications.service';
import { fetch } from '@ngrx/router-store/data-persistence';

@Injectable()
export class NotificationsEffects {
    loadNotifications$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(NotificationsActions.loadNotifications),
            fetch({
                run: ({ cursor }) => {
                    return this.notificationsService.getNotifications({ cursor }).pipe(
                        map(data =>
                            NotificationsActions.loadNotificationsSuccess({
                                data,
                                loading_more: cursor !== null
                            })
                        )
                    );
                },
                onError: (action, error) => {
                    console.error('Error', error);
                    return NotificationsActions.loadNotificationsFailure({ error });
                }
            })
        );
    });

    loadNotificationsSuccess$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(NotificationsActions.loadNotificationsSuccess),
                tap(({ data: { data } }) => {
                    data.forEach(notification => {
                        if (!notification.read_at) {
                            setTimeout(() => {
                                this.messagingService.pushNotification(notification);
                            }, 1000);
                        }
                    });
                })
            );
        },
        { dispatch: false }
    );

    markNotificationAsRead$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(NotificationsActions.markNotificationAsRead),
            concatMap(({ id }) =>
                this.notificationsService.markNotificationAsRead(id).pipe(
                    map(() => NotificationsActions.markNotificationAsReadSuccess({ id })),
                    catchError(error => of(NotificationsActions.markNotificationAsReadFailure({ id, error })))
                )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private notificationsService: NotificationsService,
        private messagingService: MessagingService
    ) {}
}
